import { TemplateListProps } from './TemplateList'
import TemplateList from './TemplateListLazy'

export default TemplateList
export type { TemplateListProps as CopyTemplateListProps }
